import { render, staticRenderFns } from "./productCategories.vue?vue&type=template&id=a6d83470&"
import script from "./productCategories.vue?vue&type=script&lang=js&"
export * from "./productCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports